import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { Link } from 'react-router';
import Logo from 'components/Logo';
import ThemeToggle from 'components/ThemeToggle';

const messages = defineMessages({
  PASSWORD_TOKEN: {
    id: 'RequestPasswordResetFailed.PASSWORD_TOKEN',
    defaultMessage: 'Ihr Passworttoken ist abgelaufen',
  },
  TEXT_RESET_PASSWORD: {
    id: 'RequestPasswordResetFailed.TEXT_RESET_PASSWORD',
    defaultMessage: 'Der Link um das Passwort zurückzusetzen ist nur einmal gültig. '
      + 'Bitte generieren Sie einen neuen Link falls sie Ihr Passwort erneut ändern möchten.',
  },
  LINK_REQUEST_PASSWORD: {
    id: 'RequestPasswordResetFailed.LINK_REQUEST_PASSWORD',
    defaultMessage: 'Neuen Link anfordern',
  },
  BACK_TO_LOGIN: {
    id: 'RequestPasswordResetFailed.BACK_TO_LOGIN',
    defaultMessage: 'Zurück zum Login',
  },
});

class RequestPasswordResetFailed extends React.PureComponent {
    render() {
      const { intl: { formatMessage } } = this.props;

        return (
            <div className="anonymous-container" style={{ minHeight: '100vh', width: '100%', position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 20px', background: 'var(--bg-color)' }}>
                <div className="anonymous-card-wrapper" style={{ width: '100%', maxWidth: '480px' }}>
                    <div className="anonymous-card" style={{ backgroundColor: 'var(--panel-bg)', borderRadius: '32px', boxShadow: 'var(--glass-shadow)', border: '1px solid var(--panel-border)', overflow: 'hidden' }}>
                        {/* Logo Header */}
                        <div className="anonymous-header" style={{ position: 'relative', padding: '32px 0', borderBottom: '1px solid var(--panel-border)', backgroundColor: 'var(--panel-bg)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Logo large />
                            <div className="anonymous-theme-toggle">
                                <ThemeToggle />
                            </div>
                        </div>

                        {/* Content */}
                        <div style={{ padding: '40px 48px', textAlign: 'center' }}>
                            {/* Error Icon */}
                            <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: 'rgba(239, 68, 68, 0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px' }}>
                                <i className="fa fa-exclamation-triangle" style={{ fontSize: '28px', color: '#ef4444' }} aria-hidden="true" />
                            </div>

                            <h1 style={{ margin: '0 0 16px 0', fontSize: '24px', fontWeight: 'bold', color: 'var(--text-color)' }}>
                                {formatMessage(messages.PASSWORD_TOKEN)}
                            </h1>
                            <p style={{ color: 'var(--text-muted)', fontSize: '15px', lineHeight: '1.6', marginBottom: '32px' }}>
                                {formatMessage(messages.TEXT_RESET_PASSWORD)}
                            </p>

                            {/* Primary Action */}
                            <Link
                                to="/requestPasswortReset"
                                style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '12px 28px', background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)', color: '#fff', borderRadius: '12px', textDecoration: 'none', fontWeight: '600', fontSize: '15px', boxShadow: '0 4px 14px rgba(59, 130, 246, 0.3)', marginBottom: '16px', width: '100%', justifyContent: 'center' }}
                                onMouseEnter={(e) => e.currentTarget.style.background = 'linear-gradient(135deg, #4f46e5 0%, #3b82f6 100%)'}
                                onMouseLeave={(e) => e.currentTarget.style.background = 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)'}
                            >
                                <i className="fa fa-refresh" aria-hidden="true" /> {formatMessage(messages.LINK_REQUEST_PASSWORD)}
                            </Link>

                            {/* Secondary Action */}
                            <div style={{ marginTop: '8px' }}>
                                <Link
                                    to="/login"
                                    style={{ color: 'var(--text-muted)', textDecoration: 'none', fontWeight: '500', display: 'inline-flex', alignItems: 'center', gap: '8px' }}
                                    onMouseEnter={(e) => e.currentTarget.style.color = '#3b82f6'}
                                    onMouseLeave={(e) => e.currentTarget.style.color = 'var(--text-muted)'}
                                >
                                    <i className="fa fa-arrow-left" aria-hidden="true" /> {formatMessage(messages.BACK_TO_LOGIN)}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(RequestPasswordResetFailed);
